module.exports = __webpack_public_path__ + "static/img/pattern-img.ca3dc0cf.png";